import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_COM003_Request,
  IAPI_COM003_Response,
} from "../../../type/apiType";

// 退職者認証
const httpAPI_COM003 = async (
  param: IAPI_COM003_Request
): Promise<IAPI_COM003_Response> => {
  let res = await http.post(ApiUrl.API_COM003, {
    ...param,
  });

  return res.data;
};

export { httpAPI_COM003 };
